<template>
  <div class="termos-de-uso-page">
    <!-- Conteúdo principal -->
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-10 col-xl-8">
          <div class="card shadow">
            <div class="card-header bg-white">
              <h3 class="card-title mb-0 text-center">
                <i class="fas fa-file-contract text-primary mr-2"></i>
                Termos de Compromisso
              </h3>
            </div>
            <div class="card-body">
              <div v-if="carregando" class="text-center py-5">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Carregando...</span>
                </div>
                <p class="mt-3 text-muted">Carregando termos...</p>
              </div>
              
              <div v-else-if="termosJaAceitos" class="text-center py-5">
                <i class="fas fa-check-circle text-success fa-4x mb-4"></i>
                <h4 class="text-success mb-3">Termos já aceitos!</h4>
                <p class="text-muted mb-4">
                  Você já aceitou os termos de compromisso anteriormente.<br>
                  Agora você pode continuar usando o sistema normalmente.
                </p>
                <button 
                  type="button" 
                  class="btn btn-primary btn-lg px-5 mr-3"
                  @click="irParaDashboard"
                >
                  <i class="fas fa-tachometer-alt mr-2"></i>
                  Ir para Dashboard
                </button>
                <button 
                  type="button" 
                  class="btn btn-outline-secondary btn-lg px-4"
                  @click="logout"
                >
                  <i class="fas fa-sign-out-alt mr-2"></i>
                  Sair
                </button>
              </div>
              
              <!-- Formulário para aceitar termos -->
              <div v-else-if="termos && termos.content" class="termos-content">
                <div v-html="termos.content"></div>
                
                <hr class="my-4">
                
                <div class="form-check mb-4" id="aceiteTermosContainer">
                  <input 
                    class="custom-checkbox mr-3" 
                    type="checkbox" 
                    v-model="aceito" 
                    id="aceiteTermos"
                    :disabled="carregando"
                  >
                  <label class="form-check-label d-inline-block" for="aceiteTermos">
                    Declaro que já tive acesso, li e assinei os termos de compromisso completo.
                  </label>
                </div>
                
                <div class="text-center">
                    <button 
                        type="button" 
                        class="btn btn-success btn-lg px-5 mr-3"
                        :disabled="!aceito || carregando"
                        @click="aceitarTermos"
                    >
                        <i class="fas fa-check mr-2"></i>
                        Aceitar e Continuar
                    </button>
                    
                    <button 
                        type="button" 
                        class="btn btn-outline-secondary btn-lg px-4"
                        @click="logout"
                        :disabled="carregando"
                        >
                        <i class="fas fa-arrow-left mr-2"></i>
                        Sair
                    </button>
                </div>
              </div>
              
              <div v-else class="text-center py-5">
                <i class="fas fa-exclamation-triangle text-warning fa-3x mb-3"></i>
                <h5>Sem termos encontrados</h5>
                <p class="text-muted">Não há termos de compromisso disponíveis no momento.</p>
                <router-link to="/dashboard" class="btn btn-primary">
                  <i class="fas fa-home mr-2"></i>
                  Ir para Dashboard
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermosUso',
  
  data() {
    return {
      carregando: false,
      termos: null,
      aceito: false,
      termosJaAceitos: false
    };
  },
  
  mounted() {
    this.carregarTermos();
  },
  
  methods: {
    async carregarTermos() {
      try {
        this.carregando = true;
                
        if (!this.termosJaAceitos) {
          const response = await axios.get('/api/dashboard/termos-ativo', {
            params: {
              tecnico_id: this.$store.state.user.tecnico.id
            }
          });
          this.termosJaAceitos = response.data.accepted;
          this.termos = response.data.data;
        }
      } catch (error) {
        console.error('Erro ao carregar termos:', error);
      } finally {
        this.carregando = false;
      }
    },
    
    async aceitarTermos() {
      if (this.aceito) {
        try {
          this.carregando = true;
          const response = await axios.post('/api/dashboard/assinar-termos', { termos_id: this.termos.id, tecnico_id: this.$store.state.user.tecnico.id });

          if (response.data.success) {
            this.$store.dispatch('fetchUserData');
            this.$router.push('/dashboard');
            return;
          }
        } catch (error) {
          swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Houve um problema ao registrar sua aceitação. Por favor, tente novamente.',
            confirmButtonText: 'OK'
          });
        } finally {
          this.carregando = false;
        }
      }
    },

    logout() {
      this.carregando = true;
      this.$store.commit("logout");
      socket.disconnect();
      setTimeout(() => {
        this.$router.push("/auth/login");
      }, 100);
    },
    
    irParaDashboard() {
      this.$router.push('/dashboard/home');
    }
  }
};
</script>

<style scoped>
.termos-de-uso-page {
  padding: 20px 0;
  background-color: #f8f9fa;
  min-height: calc(100vh - 100px);
}

.card {
  border: none;
  border-radius: 10px;
}

.card-header {
  border-bottom: 1px solid #dee2e6;
  border-radius: 10px 10px 0 0 !important;
}

.termo-content {
  line-height: 1.6;
}

.termo-content h1, 
.termo-content h2, 
.termo-content h3, 
.termo-content h4, 
.termo-content h5, 
.termo-content h6 {
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
}

.termo-content p {
  margin-bottom: 1rem;
  text-align: justify;
}

.termo-content ul, 
.termo-content ol {
  margin-bottom: 1rem;
  padding-left: 2rem;
}

.form-check-input:checked {
  background-color: #28a745;
  border-color: #28a745;
}

/* Estilos customizados para checkbox (baseado no InputMaster.vue) */
.custom-checkbox {
  /* Remove estilos nativos */
  -webkit-appearance: none;
  appearance: none;
  margin: 0;

  font: inherit;
  color: #007bff;
  width: 1.15em;
  height: 1.15em;
  border: 0.15em solid currentColor;
  border-radius: 0.15em;
  transform: translateY(-0.075em);

  display: grid;
  place-content: center;
  cursor: pointer;
}

.custom-checkbox::before {
  content: "";
  width: 0.65em;
  height: 0.65em;
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  transform: scale(0);
  transform-origin: bottom left;
  transition: 120ms transform ease-in-out;
  background-color: #007bff;
}

.custom-checkbox:checked::before {
  transform: scale(1);
}

.custom-checkbox:focus {
  outline: max(2px, 0.15em) solid currentColor;
  outline-offset: max(2px, 0.15em);
}

.custom-checkbox:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.form-check-label {
  cursor: pointer;
  user-select: none;
  line-height: 1.5;
  font-size: 14px;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .termos-de-uso-page {
    padding: 10px 0;
  }
  
  .btn-lg {
    padding: 0.75rem 2rem;
    font-size: 1rem;
    margin-bottom: 10px;
  }
  
  .btn-lg.mr-3 {
    margin-right: 0 !important;
    margin-bottom: 15px;
  }
}

#aceiteTermosContainer {
    display: flex;
    align-items: flex-end;
}
</style>